import { useEffect } from "react";

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

const loadFacebookPixel = (pixelId: string) => {
  if (!window.fbq) {
    (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function (...args: any[]) {
        // eslint-disable-next-line prefer-spread
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = "https://connect.facebook.net/en_US/fbevents.js";
      s = b.getElementsByTagName(e)[0];
      s.parentNode?.insertBefore(t, s);
    })(window, document, "script");
  }

  window.fbq?.("init", pixelId);
  window.fbq?.("track", "PageView");
};

export const useFacebookPixel = (pixelId: string) => {
  useEffect(() => {
    if (pixelId) {
      loadFacebookPixel(pixelId);
    }
  }, [pixelId]);
};
